import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
} from '@pf/shared-utility';
import {
    PickListCreate,
    PickListDto,
    PickListRead,
    PickListSearchParams,
} from '../../entities/pick-list.dto';
import { ResourceAuthSymbol } from '@pf/shared/util-platform';

const symbols = entitySymbols(PFWmsEntities.PickList);

withDefaultEntityMetadata<PickListDto>(symbols.dto, {
    name: String,
    assignedTo: String,
    pickByDate: String,
    organizedBy: String,
    status: String,
    picks: [Object],
    warehouse: Object,
    warehouseId: String,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultEntityMetadata<PickListRead>(symbols.entity, {
    picks: [Object],
    warehouse: Object,
    warehouseId: String,
    assignedTo: String,
    pickByDate: String,
    organizedBy: String,
    status: String,
    resourceAuth: ResourceAuthSymbol,
});

withMetadata<PickListCreate>(symbols.createBody, {
    warehouseId: String,
    assignedTo: String,
    pickByDate: String,
    organizedBy: String,
    status: String,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultSearchParamsMetadata<PickListSearchParams>(symbols.searchParams, {});

export const PickListMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PickListRead, PickListDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<PickListDto, PickListRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<PickListDto, PickListCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<PickListDto>, PickListSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
